/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-restricted-globals */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  faChevronLeft,
  faCalendarAlt,
  faMoneyBill,
  faFilter,
  faCheckCircle,
  faWarning,
} from '@fortawesome/free-solid-svg-icons';
import {
  Tab, Tabs, TabList, TabPanel,
} from 'react-tabs';
import moment from 'moment';
import Swal from 'sweetalert2';
import { formatCount, isValidIndianPhoneNumber, isValidName } from '../../components/Validators';
import CountUp from '../../components/CountUp';
import Search from '../../components/Search';
import LoadingModal from '../../components/LoadingModal';
import logoImg from '../../assets/images/logo.png';
import {
  getAllHprPendingPlantSideRequestDetailsByType, getAllHprCompletedPlantSideRequestDetailsByType, filterPlantSideNewHprUsersPendingrequests, filterPlantSideNewHprUsersCompletedrequests,
  getcountDigitalRegistraion,
} from '../../store/modules/newUser/actions';
import {
  selectIsLoading,
  selectPendingUserPlantSide,
  selectCompletedUserPlantSide,
  selectDigitalRegistrationCount,
} from '../../store/modules/newUser/selectors';
import ModalForHprFilter from '../../components/ModalForHprFilter';
import './PendingHprApprovalForplantIc.scss';
import withScreenRefreshDetection from '../../utils/withScreenRefreshDetection';

const PendingHprApprovalForplantIc = (props) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [query, setQuery] = useState(null);
  const [showModalForHprFilter, setshowModalForHprFilter] = useState(false);
  const [filters, setFilters] = useState({
    mobileNumber: null,
    vendorCode: null,
    fromDate: null,
    toDate: null,
  });
  const [dates, setDates] = useState({
    startDate: null,
    endDate: null,
  });

  const dispatch = useDispatch();
  const upcoming = useSelector((state) => selectPendingUserPlantSide(state));
  console.log('upcoming', upcoming);
  const pastHeld = useSelector((state) => selectCompletedUserPlantSide(state));
  const count = useSelector((state) => selectDigitalRegistrationCount(state));
  console.log('count', count);
  const isLoading = useSelector((state) => selectIsLoading(state));
  const filterAppliedForWaitingUsers = localStorage.getItem(
    'isFilterAppliedForWaitingUsers',
  );
  const filterAppliedForCompletedUsers = localStorage.getItem(
    'isFilterAppliedForCompletedUsers',
  );
  const values = {
    page: 1,
    limit: 10,
  };

  const fetchDetailsBasedOnStates = (state) => {
    if (tabIndex === 1) {
      values.requestType = 'completed';
      dispatch(getAllHprCompletedPlantSideRequestDetailsByType(values));
    } else if (tabIndex === 2) {
      values.requestType = 'rejected';
      dispatch(getAllHprCompletedPlantSideRequestDetailsByType(values));
    } else {
      dispatch(getAllHprPendingPlantSideRequestDetailsByType(values));
    }
  };
  const handleConfirmPendingUsers = () => {
    localStorage.removeItem('isFilterAppliedForWaitingUsers');
    fetchDetailsBasedOnStates();
  };

  const handleConfirmCompletedUsers = () => {
    localStorage.removeItem('isFilterAppliedForCompletedUsers');
    fetchDetailsBasedOnStates();
  };

  useEffect(() => {
    if (tabIndex === 0 && filterAppliedForWaitingUsers) {
      Swal.fire({
        icon: 'warning',
        title:
          'Filter applied for pending users, do you want to continue anyway?',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: '#229945',
        cancelButtonColor: '#f26868',
        confirmButtonText: 'Continue',
        cancelButtonText: 'Remove Filter',
        toast: true,
      }).then((result) => {
        if (result.isDismissed) {
          handleConfirmPendingUsers();
        }
      });
    } else if ((tabIndex === 1 || tabIndex === 2) && filterAppliedForCompletedUsers) {
      Swal.fire({
        icon: 'warning',
        title:
          'Filter applied for completed users, do you want to continue anyway?',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: '#229945',
        cancelButtonColor: '#f26868',
        confirmButtonText: 'Continue',
        cancelButtonText: 'Remove Filter',
        toast: true,
      }).then((result) => {
        if (result.isDismissed) {
          handleConfirmCompletedUsers();
        }
      });
    } else {
      fetchDetailsBasedOnStates();
    }
  }, [tabIndex, filterAppliedForWaitingUsers, filterAppliedForCompletedUsers]);
  useEffect(() => {
    if (props?.isRefreshed) {
      localStorage.removeItem('filterAppliedForCompletedUsers');
      localStorage.removeItem('isFilterAppliedForWaitingUsers');
    }
  }, [props?.isRefreshed]);
  const handleChange = (event) => {
    const { value } = event.target;
    setQuery(value);
  };

  const nextUpcomingPage = (page) => {
    const requestData = {
      page,
      limit: 10,
      mobileNumber: filters.mobileNumber,
      fromDate: filters.fromDate,
      toDate: filters.toDate,
    };
    dispatch(getAllHprPendingPlantSideRequestDetailsByType(requestData));
  };

  const previousUpcomingPage = (page) => {
    const requestData = {
      page,
      limit: 10,
      mobileNumber: filters.mobileNumber,
      fromDate: filters.fromDate,
      toDate: filters.toDate,
    };
    dispatch(getAllHprPendingPlantSideRequestDetailsByType(requestData));
  };

  const nextPastHeldPage = (page, requestType) => {
    const requestData = {
      page,
      limit: 10,
      mobileNumber: filters.mobileNumber,
      fromDate: filters.fromDate,
      toDate: filters.toDate,
      requestType,
    };
    dispatch(getAllHprCompletedPlantSideRequestDetailsByType(requestData));
  };

  const previousPastHeldPage = (page, requestType) => {
    const requestData = {
      page,
      limit: 10,
      mobileNumber: filters.mobileNumber,
      fromDate: filters.fromDate,
      toDate: filters.toDate,
      requestType,
    };
    dispatch(getAllHprCompletedPlantSideRequestDetailsByType(requestData));
  };

  const handleOnFilter = () => {
    setshowModalForHprFilter(!showModalForHprFilter);
  };

  const submitFilter = (e) => {
    const filterValues = {
      mobileNumber: e?.mobileNumber,
      vendorCode: e?.vendorCode,
      fromDate: moment(e?.fromDate).format('DD/MM/YYYY'),
      page: 1,
      limit: 10,
      toDate: moment(e?.toDate).format('DD/MM/YYYY'),
    };
    setFilters(filterValues);
    if (tabIndex === 0) {
      dispatch(filterPlantSideNewHprUsersPendingrequests(filterValues));
      localStorage.setItem('isFilterAppliedForWaitingUsers', true);
    } else if (tabIndex === 1) {
      filterValues.requestType = 'completed';
      dispatch(filterPlantSideNewHprUsersCompletedrequests(filterValues));
      console.log('filterValues', filterValues);
      localStorage.setItem('isFilterAppliedForCompletedUsers', true);
    } else if (tabIndex === 2) {
      filterValues.requestType = 'rejected';
      dispatch(filterPlantSideNewHprUsersCompletedrequests(filterValues));
      localStorage.setItem('isFilterAppliedForCompletedUsers', true);
    }
  };
  const handleOnBackPress = () => {
    if (tabIndex === 0) {
      dispatch(getAllHprPendingPlantSideRequestDetailsByType());
    }
    dispatch(getAllHprCompletedPlantSideRequestDetailsByType(values));
  };
  return (
    <>
      <div className="admin-orders">
        {tabIndex === 0 && filterAppliedForWaitingUsers ? (
          <div className="filterAppliedFlag">
            <FontAwesomeIcon icon={faWarning} style={{ marginRight: 5 }} />
            In order to dynamically remove the filter that has been applied to pending users, please refresh the page.
          </div>
        ) : (tabIndex === 1 || tabIndex === 2) && filterAppliedForCompletedUsers ? (
          <div className="filterAppliedFlag">
            <FontAwesomeIcon icon={faWarning} style={{ marginRight: 5 }} />
            In order to dynamically remove the filter that has been applied to completed users, please refresh the page.
          </div>
        ) : null}
        <div className="row">
          <div className="col-12">
            <div className="heading">
              <p className="heading__title" onClick={handleOnBackPress}>
                <FontAwesomeIcon
                  icon={faChevronLeft}
                />
                {' '}
                Pending HPR Registrations
              </p>
            </div>
          </div>
        </div>

        <Tabs
          defaultIndex={0}
          selectedIndex={tabIndex}
          onSelect={(index) => setTabIndex(index)}
        >
          <TabList className="row between tab-list">
            <Tab className="col-4 tab">
              <div className={`type-card ${tabIndex === 0 ? 'selected' : ''}`}>
                Waiting for Approval
                {
                  (count > 0 && tabIndex === 0) ? (
                    <span className="count-ui danger">
                      {formatCount(count)}
                    </span>
                  ) : null
                }
              </div>
            </Tab>
            <Tab className="col-4 tab">
              <div className={`type-card ${tabIndex === 1 ? 'selected' : ''}`}>
                Completed
                {(count > 0 && tabIndex === 1) ? (
                  <span className="count-ui">
                    {formatCount(count)}
                  </span>
                ) : null}
              </div>
            </Tab>
            <Tab className="col-4 tab">
              <div className={`type-card ${tabIndex === 2 ? 'selected' : ''}`}>
                Rejected
              </div>
            </Tab>
          </TabList>
          {/* PENDING TAB */}
          <TabPanel className="appointments-tab-panel">
            <div className="row middle">
              <div className="col-12 col-md-2">
                <div className="buttons">
                  <button
                    type="button"
                    className="button green"
                    onClick={handleOnFilter}
                  >
                    <FontAwesomeIcon icon={faFilter} className="button__icon" />
                    Filter
                  </button>
                </div>
              </div>
            </div>
            <div className="row">
              {upcoming && upcoming.paginate && upcoming.paginate.length
                ? upcoming.paginate.map((item, index) => (
                  <div className="col-12 col-lg-12" key={item.id || index}>
                    <div className="card">
                      <div className="card__left">
                        <div className="card__avatar">
                          {item?.profilePicture ? (
                            <img src={item?.profilePicture} alt="order" />
                          ) : (
                            <img src={logoImg} alt="user" />
                          )}
                        </div>
                        <div className="row between col-9">
                          <div className="card__text">
                            <div>
                              <span className="card__title">
                                HPR / DF Name :
                                {' '}
                              </span>
                              {item ? item?.hprOrDfName : ''}
                            </div>
                            <div>
                              <span className="card__title">
                                Registration ID :
                                {' '}
                              </span>
                              {item ? item?.id : ''}
                            </div>
                            <div>
                              <span className="card__title">Phone: </span>
                              {item ? item?.mobileNumber : ''}
                            </div>
                            <div>
                              <span className="card__title">Role: </span>
                              {item
                                ? item?.hprOrDf === 'HPR'
                                  ? 'HP Representative'
                                  : 'Dairy Farmer'
                                : ''}
                            </div>
                          </div>
                          <div className="card__text">
                            <div>
                              <span className="card__title">
                                User Created At :
                                {' '}
                              </span>
                              {moment(item?.createdAt).format(
                                'DD/MM/YYYY',
                              )}
                            </div>
                            <div>
                              <span className="card__title">
                                Plant Code :
                                {' '}
                              </span>
                              {item?.plantCode ?? 'N/A'}
                            </div>
                            <div>
                              <span className="card__title">
                                MCC Name :
                                {' '}
                              </span>
                              {item?.mccName ?? 'N/A'}
                            </div>
                            <div>
                              <span className="card__title">
                                User Created Time :
                                {' '}
                              </span>
                              {moment(item?.createdAt).format('hh:mm a')}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card__right">
                        <Link
                          to={`/plant-admin/pendingHprRegistrations/${item?.id}`}
                          className="card__button"
                        >
                          View
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
                : null}
              {!isLoading && !upcoming && (
                <div className="col-12 col-lg-12 d-flex-col middle">
                  <div className="notFound">
                    <FontAwesomeIcon icon={faCalendarAlt} className="notFound__icon" />
                    <span className="notFound__text">No upcoming User Request found</span>
                  </div>
                </div>
              )}
            </div>
            {upcoming
              ? (
                <div className="row">
                  <div className="col-12 col-lg-12 d-flex-col middle">
                    <div className="pagination">
                      <button
                        type="button"
                        className="pagination__btn"
                        disabled={!upcoming.Previous}
                        onClick={() => previousUpcomingPage(upcoming.Previous.page)}
                      >
                        <FontAwesomeIcon icon={faChevronLeft} className="pagination__btn__icon" />
                      </button>
                      <span className="pagination__page">
                        {upcoming.Next
                          ? upcoming.Next.page - 1
                          : upcoming.Previous
                            ? upcoming.Previous.page + 1
                            : 1}
                      </span>
                      <button
                        type="button"
                        className="pagination__btn"
                        disabled={!upcoming.Next}
                        onClick={() => nextUpcomingPage(upcoming.Next.page)}
                      >
                        <FontAwesomeIcon icon={faChevronRight} className="pagination__btn__icon" />
                      </button>
                    </div>
                  </div>
                </div>
              ) : null}
          </TabPanel>
          {/* COMPLETED TAB */}
          <TabPanel className="appointments-tab-panel">
            <div className="row middle">
              <div className="col-12 col-md-2">
                <div className="buttons">
                  <button
                    type="button"
                    className="button green"
                    onClick={handleOnFilter}
                  >
                    <FontAwesomeIcon icon={faFilter} className="button__icon" />
                    Filter
                  </button>
                </div>
              </div>
            </div>
            <div className="row">
              {pastHeld && pastHeld.paginate && pastHeld.paginate.length
                ? pastHeld.paginate
                  .filter((item) => (item.approvedByPlantIc !== 'rejected') && (item.approvedByRIPandI !== 'rejected'))
                  .map((item, index) => (
                    <div className="col-12 col-lg-12" key={item.id || index}>
                      <div className="card">
                        <div className="card__left">
                          <div className="card__avatar">
                            {item?.profilePicture ? (
                              <img src={item?.profilePicture} alt="order" />
                            ) : (
                              <img src={logoImg} alt="user" />
                            )}
                          </div>
                          <div className="row between col-9">
                            <div className="card__text">
                              <div>
                                <span className="card__title">
                                  HPR / DF Name :
                                  {' '}
                                </span>
                                {item ? item?.hprOrDfName : ''}
                              </div>
                              <div>
                                <span className="card__title">
                                  Registration ID :
                                  {' '}
                                </span>
                                {item ? item?.id : ''}
                              </div>
                              <div>
                                <span className="card__title">Phone: </span>
                                {item ? item?.mobileNumber : ''}
                              </div>
                              <div>
                                <span className="card__title">Role: </span>
                                {item
                                  ? item?.hprOrDf === 'HPR'
                                    ? 'HP Representative'
                                    : 'Dairy Farmer'
                                  : ''}
                              </div>
                            </div>
                            <div className="card__text">
                              <div>
                                <span className="card__title">
                                  User Created At :
                                  {' '}
                                </span>
                                {moment(item?.createdAt).format('DD/MM/YYYY')}
                              </div>
                              <div>
                                <span className="card__title">
                                  Plant Code :
                                  {' '}
                                </span>
                                {item?.plantCode ?? 'N/A'}
                              </div>
                              <div>
                                <span className="card__title">
                                  MCC Name :
                                  {' '}
                                </span>
                                {item?.mccName ?? 'N/A'}
                              </div>
                              <div>
                                <span className="card__title">
                                  User Created Time :
                                  {' '}
                                </span>
                                {moment(item?.createdAt).format('hh:mm a')}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card__right">
                          <div
                            className={`card__text--${item?.status === 'approved' ? 'success'
                              : item?.approvedByPlantIc === 'pending' ? 'warning' : item?.approvedByPlantIc === 'rejected' ? 'danger' : ''}`}
                          >
                            <span className="card__title">
                              Status :
                              {' '}
                            </span>
                            {item?.approvedByPlantIc?.toUpperCase()}
                          </div>
                          <Link
                            to={`/plant-admin/pendingHprRegistrations/${item.id}`}
                            className="card__button"
                          >
                            View
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))
                : null}
              {!isLoading && !pastHeld && (
                <div className="col-12 col-lg-12 d-flex-col middle">
                  <div className="notFound">
                    <FontAwesomeIcon icon={faCalendarAlt} className="notFound__icon" />
                    <span className="notFound__text">No completed users found</span>
                  </div>
                </div>
              )}
            </div>
            {pastHeld
              ? (
                <div className="row">
                  <div className="col-12 col-lg-12 d-flex-col middle">
                    <div className="pagination">
                      <button
                        type="button"
                        className="pagination__btn"
                        disabled={!pastHeld.Previous}
                        onClick={() => previousPastHeldPage(pastHeld.Previous.page, 'completed')}
                      >
                        <FontAwesomeIcon icon={faChevronLeft} className="pagination__btn__icon" />
                      </button>
                      <span className="pagination__page">
                        {pastHeld.Next
                          ? pastHeld.Next.page - 1
                          : pastHeld.Previous
                            ? pastHeld.Previous.page + 1
                            : 1}
                      </span>
                      <button
                        type="button"
                        className="pagination__btn"
                        disabled={!pastHeld.Next}
                        onClick={() => nextPastHeldPage(pastHeld.Next.page, 'completed')}
                      >
                        <FontAwesomeIcon icon={faChevronRight} className="pagination__btn__icon" />
                      </button>
                    </div>
                  </div>
                </div>
              ) : null}
          </TabPanel>
          {/* REJECTED TAB */}
          <TabPanel className="appointments-tab-panel">
            <div className="row middle">
              <div className="col-12 col-md-2">
                <div className="buttons">
                  <button
                    type="button"
                    className="button green"
                    onClick={handleOnFilter}
                  >
                    <FontAwesomeIcon icon={faFilter} className="button__icon" />
                    Filter
                  </button>
                </div>
              </div>
            </div>
            <div className="row">
              {pastHeld && pastHeld.paginate && pastHeld.paginate.length
                ? pastHeld.paginate
                  .filter((item) => item.approvedByPlantIc === 'rejected' || item.approvedByRHPI === 'rejected')
                  .map((item, index) => (
                    <div className="col-12 col-lg-12" key={item.id || index}>
                      <div className="card">
                        <div className="card__left">
                          <div className="card__avatar">
                            {item?.profilePicture ? (
                              <img src={item?.profilePicture} alt="order" />
                            ) : (
                              <img src={logoImg} alt="user" />
                            )}
                          </div>
                          <div className="row between col-9">
                            <div className="card__text">
                              <div>
                                <span className="card__title">
                                  HPR / DF Name :
                                  {' '}
                                </span>
                                {item ? item?.hprOrDfName : ''}
                              </div>
                              <div>
                                <span className="card__title">
                                  Registration ID :
                                  {' '}
                                </span>
                                {item ? item?.id : ''}
                              </div>
                              <div>
                                <span className="card__title">Phone: </span>
                                {item ? item?.mobileNumber : ''}
                              </div>
                              <div>
                                <span className="card__title">Role: </span>
                                {item
                                  ? item?.hprOrDf === 'HPR'
                                    ? 'HP Representative'
                                    : 'Dairy Farmer'
                                  : ''}
                              </div>
                              <div>
                                <span className="card__title">
                                  Reason:
                                  {' '}
                                </span>
                                <span className="card__text--danger">
                                  {item ? item?.plantIcRejectionReason : ''}
                                </span>
                              </div>
                            </div>
                            <div className="card__text">
                              <div>
                                <span className="card__title">
                                  User Created At :
                                  {' '}
                                </span>
                                {moment(item?.createdAt).format('DD/MM/YYYY')}
                              </div>
                              <div>
                                <span className="card__title">
                                  Plant Code :
                                  {' '}
                                </span>
                                {item?.plantCode ?? 'N/A'}
                              </div>
                              <div>
                                <span className="card__title">
                                  MCC Name :
                                  {' '}
                                </span>
                                {item?.mccName ?? 'N/A'}
                              </div>
                              <div>
                                <span className="card__title">
                                  User Created Time :
                                  {' '}
                                </span>
                                {moment(item?.createdAt).format('hh:mm a')}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card__right">
                          <div
                            className={`card__text--${item?.status === 'approved' ? 'success'
                              : item?.approvedByPlantIc === 'pending' ? 'warning' : item?.approvedByPlantIc === 'rejected' ? 'danger' : ''}`}
                          >
                            <span className="card__title">
                              Status :
                              {' '}
                            </span>
                            {item?.approvedByPlantIc?.toUpperCase()}
                          </div>
                          <Link
                            to={`/plant-admin/pendingHprRegistrations/${item.id}`}
                            className="card__button"
                          >
                            View
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))
                : null}
              {!isLoading && !pastHeld && (
                <div className="col-12 col-lg-12 d-flex-col middle">
                  <div className="notFound">
                    <FontAwesomeIcon icon={faCalendarAlt} className="notFound__icon" />
                    <span className="notFound__text">No rejected users found</span>
                  </div>
                </div>
              )}
            </div>
            {pastHeld
              ? (
                <div className="row">
                  <div className="col-12 col-lg-12 d-flex-col middle">
                    <div className="pagination">
                      <button
                        type="button"
                        className="pagination__btn"
                        disabled={!pastHeld.Previous}
                        onClick={() => previousPastHeldPage(pastHeld.Previous.page, 'rejected')}
                      >
                        <FontAwesomeIcon icon={faChevronLeft} className="pagination__btn__icon" />
                      </button>
                      <span className="pagination__page">
                        {pastHeld.Next
                          ? pastHeld.Next.page - 1
                          : pastHeld.Previous
                            ? pastHeld.Previous.page + 1
                            : 1}
                      </span>
                      <button
                        type="button"
                        className="pagination__btn"
                        disabled={!pastHeld.Next}
                        onClick={() => nextPastHeldPage(pastHeld.Next.page, 'rejected')}
                      >
                        <FontAwesomeIcon icon={faChevronRight} className="pagination__btn__icon" />
                      </button>
                    </div>
                  </div>
                </div>
              ) : null}
          </TabPanel>
        </Tabs>
        {showModalForHprFilter ? (
          <ModalForHprFilter
            show={showModalForHprFilter}
            toggle={handleOnFilter}
            onSubmit={submitFilter}
          />
        ) : null}
      </div>
      <LoadingModal show={isLoading} />
    </>
  );
};

export default withScreenRefreshDetection(PendingHprApprovalForplantIc);
